module.exports = __webpack_public_path__ + "assets/img/icon9.99deba88.png";